export const format = (value) => {
  // console.log("--- format", value)
  if(!value) return value;
  const numDecimalPlaces = countDecimalPlaces(value);
  //console.log("---- numDecimalPlaces", numDecimalPlaces)
  if (value >= 1_000_000) {
    return `${(value / 1_000_000).toFixed(2)}M`;
  } else if (value >= 1_000) {
    return `${(value / 1_000).toFixed(2)}K`;
  } else if (value < 1) {
    return numDecimalPlaces > 4 ? String(value).substring(0, 6) : `${value}`;
  } else {
    return numDecimalPlaces > 2 ? String(value).substring(0, 4) : `${value}`;
  }
}

export const sleep = (ms) => {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export const shorterText = (text, length) => {
  return text?.length > length 
    ? text.substring(0, length) + "..." + text.substring(text.length - length, text.length) 
    : text;
}

export const countDecimalPlaces = (number) => {
  // Convert the number to a string to handle potential floating-point inaccuracies
  const numStr = String(number);

  // Check if the string contains a decimal point
  if (numStr.includes('.')) {
    // Split the string at the decimal point and get the length of the part after it
    return numStr.split('.')[1].length;
  } else {
    // If no decimal point is found, there are no decimal places
    return 0;
  }
}